import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Body, Footer, Popup } from '@calendly/ui/components/popup'
import { useDispatch } from 'react-redux'

import { resetPopup } from './slice'
import { ButtonWrapper } from './styles'

export const TaxInformationSuccessModal = () => {
  const dispatch = useDispatch()

  return (
    <Popup
      onClose={() => false}
      size="medium"
      title={I18n.t('publisher.billing.vat_id_popup.success.thank_you')}
    >
      <Body>
        {I18n.t('publisher.billing.vat_id_popup.success.message')}
      </Body>
      <Footer>
        <div />
        <ButtonWrapper>
          <Button onClick={() => dispatch(resetPopup())}>
            {I18n.t('publisher.billing.vat_id_popup.success.close')}
          </Button>
        </ButtonWrapper>
      </Footer>
    </Popup>
  )
}
